import MailboxMediaModal from "./MailboxMediaModal";

export default MailboxMediaModal;
